export { COOKIE_KEY, COOKIE_APP_ID } from '@/app/common/cookies/types';
